import { InMemoryCache, makeVar } from '@apollo/client';

import { TypedTypePolicies } from '../graphql/generated/apolloHelpers';

export const isPageLoadingVar = makeVar<boolean>(false);

const typePolicies: TypedTypePolicies = {
  Query: {
    fields: {
      companies: {
        keyArgs: [],
        merge: true,
      },
      myFolders: {
        merge: false,
      },
    },
  },
  PurchasePriceAllocation: {
    fields: {
      cashGeneratingUnits: {
        merge: false, // accept data from the server as the full new truth
      },
      intangibleAssets: {
        merge: false,
      },
    },
  },
  BalanceSheet: {
    fields: {
      items: {
        merge: false,
      },
    },
  },
  Consideration: {
    fields: {
      earnOutComponents: {
        merge: false,
      },
      deferredPayments: {
        merge: false,
      },
      adjustmentItems: {
        merge: false,
      },
    },
  },
  DCFModel: {
    fields: {
      rows: {
        merge: false,
      },
    },
  },
  RowModel: {
    fields: {
      columns: {
        merge: false,
      },
    },
  },
  ModelInputModel: {
    fields: {
      rows: {
        merge: false,
      },
    },
  },
  BalanceSheetModel: {
    fields: {
      items: {
        merge: false,
      },
    },
  },
  FairValueBalanceSheetModel: {
    fields: {
      items: {
        merge: false,
      },
    },
  },
  WaraModel: {
    fields: {
      intangibleAssets: {
        merge: false,
      },
      tangibleAssets: {
        merge: false,
      },
      residualGoodwill: {
        merge: false,
      },
    },
  },
  WorkforceValuationModel: {
    fields: {
      columns: {
        merge: false,
      },
    },
  },
  EarnOutComponentModel: {
    fields: {
      scenarios: {
        merge: false,
      },
    },
  },
  ConsiderationOverviewModel: {
    fields: {
      earnOutComponents: {
        merge: false,
      },
    },
  },
  Folder: {
    fields: {
      projects: {
        merge: false,
      },
    },
  },
};

export const cache = new InMemoryCache({
  typePolicies,
});
